import { MobileBottomNavigationContainer, Provider } from '@cian/frontend-mobile-bottom-navigation';
import { MobileSlidingContainer } from '@cian/frontend-mobile-sliding-container';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { userSelector } from '../../selectors';
import { locationIdSelector } from '../../selectors/locationIdSelector';
import { useApplicationContext } from '../../utils/applicationContext';

export const BottomNavigationContainer: React.FC = () => {
  const {
    httpApi,
    logger,
    config,
    custom: { subdomain },
  } = useApplicationContext();

  const { isAuthenticated } = useSelector(userSelector);
  const locationId = useSelector(locationIdSelector);

  return (
    <MobileSlidingContainer>
      <Provider context={{ httpApi, logger, config }}>
        <MobileBottomNavigationContainer
          pageType="chats"
          subdomain={subdomain}
          region={locationId}
          isAuthenticated={isAuthenticated}
        />
      </Provider>
    </MobileSlidingContainer>
  );
};
